module.exports = __webpack_public_path__ + "img/icon-time-white.a839bb58.svg";